(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-mystory-announcement]').forEach((bar) => {
      if (bar.dataset.ready === 'true') return;
      bar.dataset.ready = 'true';
      const storageKey = `mystory-announcement-${bar.dataset.sectionId}`;
      if (sessionStorage.getItem(storageKey) === 'closed') bar.hidden = true;
      bar.querySelector('[data-mystory-announcement-close]')?.addEventListener('click', () => {
        bar.hidden = true;
        sessionStorage.setItem(storageKey, 'closed');
      });
    });

    root.querySelectorAll('[data-mystory-header]').forEach((header) => {
      if (header.dataset.ready === 'true') return;
      header.dataset.ready = 'true';
      const drawer = header.querySelector('[data-mystory-mobile-menu]');
      const open = header.querySelector('[data-mystory-menu-open]');
      const close = header.querySelector('[data-mystory-menu-close]');
      const setOpen = (isOpen) => {
        if (!drawer) return;
        drawer.hidden = !isOpen;
        document.documentElement.classList.toggle('mystory-menu-open', isOpen);
        open?.setAttribute('aria-expanded', String(isOpen));
        if (isOpen) close?.focus();
      };
      open?.addEventListener('click', () => setOpen(true));
      close?.addEventListener('click', () => setOpen(false));
      drawer?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setOpen(false)));
      header.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') setOpen(false);
      });
    });

    root.querySelectorAll('[data-mystory-slider]').forEach((slider) => {
      if (slider.dataset.ready === 'true') return;
      slider.dataset.ready = 'true';
      const input = slider.querySelector('input[type="range"]');
      const update = () => {
        const value = Number(input?.value || 50);
        slider.style.setProperty('--mystory-slider-position', `${value}%`);
        input?.setAttribute('aria-valuetext', `${value}% story avatar`);
      };
      input?.addEventListener('input', update);
      update();
    });

    root.querySelectorAll('[data-mystory-video]').forEach((wrapper) => {
      if (wrapper.dataset.ready === 'true') return;
      wrapper.dataset.ready = 'true';
      const video = wrapper.querySelector('video');
      const button = wrapper.querySelector('[data-mystory-video-toggle]');
      if (!video || !button) return;
      const sync = () => {
        wrapper.classList.toggle('is-playing', !video.paused);
        button.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
      };
      button.addEventListener('click', () => {
        if (video.paused) video.play();
        else video.pause();
      });
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      sync();
    });

    root.querySelectorAll('[data-mystory-catalogue]').forEach((catalogue) => {
      if (catalogue.dataset.ready === 'true') return;
      catalogue.dataset.ready = 'true';
      const search = catalogue.querySelector('[data-mystory-catalogue-search]');
      const clear = catalogue.querySelector('[data-mystory-catalogue-clear]');
      const count = catalogue.querySelector('[data-mystory-catalogue-count]');
      const grid = catalogue.querySelector('[data-mystory-catalogue-grid]');
      const cards = [...catalogue.querySelectorAll('[data-mystory-catalogue-card]')];
      const empty = catalogue.querySelector('[data-mystory-catalogue-search-empty]');
      const viewButtons = [...catalogue.querySelectorAll('[data-mystory-view]')];

      const filterCards = () => {
        const query = search?.value.trim().toLowerCase() || '';
        let visible = 0;
        cards.forEach((card) => {
          const matches = !query || card.dataset.searchText.includes(query);
          card.hidden = !matches;
          if (matches) visible += 1;
        });
        if (count) count.textContent = String(visible);
        if (clear) clear.hidden = !query;
        if (empty) empty.hidden = visible !== 0;
        if (grid) grid.hidden = visible === 0;
      };

      search?.addEventListener('input', filterCards);
      clear?.addEventListener('click', () => {
        search.value = '';
        filterCards();
        search.focus();
      });

      viewButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const isList = button.dataset.mystoryView === 'list';
          grid?.classList.toggle('is-list', isList);
          viewButtons.forEach((candidate) => {
            const active = candidate === button;
            candidate.classList.toggle('is-active', active);
            candidate.setAttribute('aria-pressed', String(active));
          });
        });
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => initialize());
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
